import React, { useState, useRef } from "react";
import { IFonctionState } from "./interface";
import { Grid, TextField } from "@mui/material";
import Box from "@mui/material/Box";

interface IAddProps {
  fonctionState: IFonctionState;
  setFonctionState: (x: IFonctionState) => void;
}


const Edit = (props: IAddProps) => {

  //props
  const {
    fonctionState, setFonctionState
  } = props


  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setFonctionState({ ...fonctionState, [name]: value })
  }


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            multiline
            minRows={5}
            size="small"
            name="fonctionAgent"
            label="Libellé fonction"
            value={fonctionState.fonctionAgent}
            onChange={handleInputChange}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
export default Edit;

